import { render } from "./Archive.vue?vue&type=template&id=421f1ea2"
import script from "./Archive.vue?vue&type=script&lang=js"
export * from "./Archive.vue?vue&type=script&lang=js"

import "./Archive.vue?vue&type=style&index=0&id=421f1ea2&lang=css"
script.render = render

export default script